import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function LaserCutterSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("laserCutter.title")}</title>
        <meta name="keywords" content={t("laserCutter.keywords")} />
        <meta name="description" content={t("laserCutter.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#2d2418]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/laser-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_-8%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#1f1810]/92 via-[#1f1810]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("laserCutter.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("laserCutter.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("laserCutter.knowledgeBase.rootLabel")}
        rootColor="#ea580c"
        treeTranslationKey="laserCutter.knowledgeBase.tree"
        i18nPrefix="laserCutter.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="laserCutter"
        images={{
          painPoints: "/solutions/laser-pain.jpeg",
          solutions: "/solutions/laser-solutions.jpeg",
          cta: "/solutions/laser-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 22%",
          solutions: "48% 28%",
          cta: "0% 5%",
        }}
      />
    </>
  );
}
